import { BehaviorSubject } from 'rxjs';

var _a;
/**
 * @fileoverview added by tsickle
 * Generated from: lib/abp-base.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpBaseConstant {
}
//#region font classes
AbpBaseConstant.cssClass = (_a = class {
    },
    _a.abp_input_control = 'abp-input-control',
    _a.abp_input_control_valid = 'valid',
    _a.abp_input_control_error = 'error',
    _a.abp_error_text = 'validation-msg',
    _a);
if (false) {
    /** @type {?} */
    AbpBaseConstant.cssClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/enums/field-type.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const FieldType = {
    Unknown: 0,
    Button: 1,
    SubmitButton: 2,
    LinkButton: 3,
    IconButton: 4,
    TransparentButton: 5,
    TransparentIconButton: 6,
    ResetButton: 7,
    Label: 8,
    FieldDisplayLabel: 9,
    Checkbox: 10,
    CheckboxList: 11,
    Textbox: 12,
    Password: 13,
    MaskedTextBox: 14,
    Date: 15,
    RadioList: 16,
    Switch: 17,
    RadioInlineList: 18,
    Dropdown: 19,
    custom: 20,
};
FieldType[FieldType.Unknown] = 'Unknown';
FieldType[FieldType.Button] = 'Button';
FieldType[FieldType.SubmitButton] = 'SubmitButton';
FieldType[FieldType.LinkButton] = 'LinkButton';
FieldType[FieldType.IconButton] = 'IconButton';
FieldType[FieldType.TransparentButton] = 'TransparentButton';
FieldType[FieldType.TransparentIconButton] = 'TransparentIconButton';
FieldType[FieldType.ResetButton] = 'ResetButton';
FieldType[FieldType.Label] = 'Label';
FieldType[FieldType.FieldDisplayLabel] = 'FieldDisplayLabel';
FieldType[FieldType.Checkbox] = 'Checkbox';
FieldType[FieldType.CheckboxList] = 'CheckboxList';
FieldType[FieldType.Textbox] = 'Textbox';
FieldType[FieldType.Password] = 'Password';
FieldType[FieldType.MaskedTextBox] = 'MaskedTextBox';
FieldType[FieldType.Date] = 'Date';
FieldType[FieldType.RadioList] = 'RadioList';
FieldType[FieldType.Switch] = 'Switch';
FieldType[FieldType.RadioInlineList] = 'RadioInlineList';
FieldType[FieldType.Dropdown] = 'Dropdown';
FieldType[FieldType.custom] = 'custom';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helper/conversion/conversion.helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class ConversionHelper {
    //#region model properties
    //#endregion model properties
    //#region constructor
    //#endregion constructor
    //#region public functions
    //#region int conversions
    /**
     * converts string to number
     * @param {?} value
     * @param {?=} defaultValue
     * @return {?}
     */
    static ToNumber(value, defaultValue = 0) {
        /** @type {?} */
        let convertedVal = defaultValue;
        if (value) {
            /** @type {?} */
            let number = Number(value);
            if (number) {
                convertedVal = number;
            }
        }
        return convertedVal;
    }
}

var _a$1, _b, _c, _d, _e;
/**
 * @fileoverview added by tsickle
 * Generated from: lib/helper/date/date.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class DateConstant {
}
DateConstant.minYear = 1900;
DateConstant.maxYear = 9999;
DateConstant.invalidDateString = 'Invalid Date';
DateConstant.stringType = 'string';
DateConstant.dateformat = (_a$1 = class {
    },
    _a$1.mmddyy_slash = 'mm/dd/yy',
    _a$1.mmddyy_hyphen = 'mm-dd-yy',
    _a$1.mmddyy_dot = 'mm.dd.yy',
    _a$1.mmddyyyy_slash = 'mm/dd/yyyy',
    _a$1.mmddyyyy_hyphen = 'mm-dd-yyyy',
    _a$1.mmddyyyy_dot = 'mm.dd.yyyy',
    _a$1.mon_dd_yyyy_space = 'mon dd yyyy',
    _a$1.month_dd_yyyy_space = 'month dd yyyy',
    _a$1.ddmmyy_slash = 'dd/mm/yy',
    _a$1.ddmmyy_hyphen = 'dd-mm-yy',
    _a$1.ddmmyy_dot = 'dd.mm.yy',
    _a$1.ddmmyyyy_slash = 'dd/mm/yyyy',
    _a$1.ddmmyyyy_hyphen = 'dd-mm-yyyy',
    _a$1.ddmmyyyy_dot = 'dd.mm.yyyy',
    _a$1.dd_mon_yyyy_space = 'dd mon yyyy',
    _a$1.dd_month_yyyy_space = 'dd month yyyy',
    _a$1.yyyymmdd_slash = 'yyyy/mm/dd',
    _a$1.yyyy_mon_dd_space = 'yyyy mon dd',
    _a$1.yyyy_month_dd_space = 'yyyy month dd',
    _a$1);
DateConstant.dateSeperator = (_b = class {
    },
    _b.slash = '/',
    _b.hyphen = '-',
    _b.dot = '.',
    _b.space = ' ',
    _b.coma = ';',
    _b);
DateConstant.monthName = (_c = class {
    },
    _c.jan = 'january',
    _c.feb = 'february',
    _c.mar = 'march',
    _c.apr = 'april',
    _c.may = 'may',
    _c.june = 'june',
    _c.july = 'july',
    _c.aug = 'august',
    _c.sep = 'september',
    _c.oct = 'october',
    _c.nov = 'november',
    _c.dec = 'december',
    _c);
DateConstant.duration = (_d = class {
    },
    _d.years = 'years',
    _d.months = 'months',
    _d.weeks = 'weeks',
    _d.days = 'days',
    _d.hours = 'hours',
    _d.minutes = 'minutes',
    _d.seconds = 'seconds',
    _d);
DateConstant.regexExp = (_e = class {
    },
    _e.alphanumeric_with_space = /[a-zA-Z0-9 ]/g,
    _e.alphanumeric = /[a-zA-Z0-9]/g,
    _e.numericOnly = /[0-9]/g,
    _e.alphabetOnly = /[a-zA-Z]/g,
    _e);
if (false) {
    /** @type {?} */
    DateConstant.minYear;
    /** @type {?} */
    DateConstant.maxYear;
    /** @type {?} */
    DateConstant.invalidDateString;
    /** @type {?} */
    DateConstant.stringType;
    /** @type {?} */
    DateConstant.dateformat;
    /** @type {?} */
    DateConstant.dateSeperator;
    /** @type {?} */
    DateConstant.monthName;
    /** @type {?} */
    DateConstant.duration;
    /** @type {?} */
    DateConstant.regexExp;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helper/date/date-part.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class DatePartModel {
    constructor() {
        //#region model properties
        //#region model properties
        this.index = -1;
        //#endregion model properties
    }
    /**
     * @return {?}
     */
    get formattedValue() {
        if (this.value) {
            if (typeof this.value === 'string') {
                if (this.value.length < this.maxLength) {
                    /** @type {?} */
                    let canAppendZero = false;
                    switch (this.duration) {
                        case DateConstant.duration.days:
                            if (this.value != '0' && this.value != '1' && this.value != '2' && this.value != '3') {
                                canAppendZero = true;
                            }
                            break;
                        case DateConstant.duration.months:
                            if (this.maxLength == 2) {
                                if (this.value != '0' && this.value != '1') {
                                    canAppendZero = true;
                                }
                            }
                            break;
                        case DateConstant.duration.years:
                            if (this.value == '0') {
                                this.value = '';
                            }
                            break;
                    }
                    if (canAppendZero) {
                        return `0${this.value}`;
                    }
                }
                else {
                    if (this.duration == DateConstant.duration.months &&
                        this.maxLength > 2) {
                        /** @type {?} */
                        let firstLetter = this.value.charAt(0).toUpperCase();
                        return `${firstLetter}${this.value.substring(1, this.value.length).toLowerCase()}`;
                    }
                }
            }
            return this.value.toString();
        }
        return '';
    }
}
if (false) {
    /** @type {?} */
    DatePartModel.prototype.index;
    /** @type {?} */
    DatePartModel.prototype.value;
    /** @type {?} */
    DatePartModel.prototype.maxLength;
    /** @type {?} */
    DatePartModel.prototype.duration;
    /** @type {?} */
    DatePartModel.prototype.regexMath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helper/date/date.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class DateModel {
    //#endregion model properties
    //#region constructor
    constructor() {
        this.datePartSorted = [];
        this.dayModel = new DatePartModel();
        this.monthModel = new DatePartModel();
        this.yearModel = new DatePartModel();
    }
    //#endregion constructor
    //#region public methods
    /**
     * sets date part values
     * @param {?} day
     * @param {?} month
     * @param {?} year
     * @param {?} seperator
     * @param {?} monthLen
     * @param {?=} yearLen
     * @return {?}
     */
    setValues(day, month, year, seperator, monthLen, yearLen = 4) {
        this.dayModel.index = day;
        this.dayModel.maxLength = 2;
        this.dayModel.duration = DateConstant.duration.days;
        this.dayModel.regexMath = DateConstant.regexExp.numericOnly;
        this.monthModel.index = month;
        this.monthModel.maxLength = monthLen;
        this.monthModel.duration = DateConstant.duration.months;
        if (monthLen > 2) {
            this.monthModel.regexMath = DateConstant.regexExp.alphabetOnly;
        }
        else {
            this.monthModel.regexMath = DateConstant.regexExp.numericOnly;
        }
        this.yearModel.index = year;
        this.yearModel.maxLength = yearLen;
        this.yearModel.duration = DateConstant.duration.years;
        this.yearModel.regexMath = DateConstant.regexExp.numericOnly;
        this.seperator = seperator;
    }
    /**
     * determines if all values are set
     * @return {?}
     */
    hasValue() {
        return (this.dayModel.index >= 0 && this.monthModel.index >= 0 && this.yearModel.index >= 0 && this.seperator);
    }
}
if (false) {
    /** @type {?} */
    DateModel.prototype.dayModel;
    /** @type {?} */
    DateModel.prototype.monthModel;
    /** @type {?} */
    DateModel.prototype.yearModel;
    /** @type {?} */
    DateModel.prototype.seperator;
    /** @type {?} */
    DateModel.prototype.datePartSorted;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helper/date/date.helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class DateHelper {
    //#region model properties
    //#endregion model properties
    //#region constructor
    constructor() {
    }
    //#endregion constructor
    //#region public functions
    //#region year
    /**
     * determines if given year YYYY number is valid
     * @param {?} year
     * @return {?}
     */
    static isValidYear(year) {
        /** @type {?} */
        let yearNum = this.getFullYear(year);
        if (yearNum != null &&
            !Number.isNaN(yearNum) &&
            yearNum > DateConstant.minYear &&
            yearNum <= DateConstant.maxYear) {
            return true;
        }
        return false;
    }
    /**
     * determines if year is a leap year
     * @param {?} year
     * @return {?}
     */
    static isLeapYear(year) {
        /** @type {?} */
        let yearNumber = this.getFullYear(year);
        if (yearNumber != null &&
            this.isValidYear(yearNumber)) {
            return ((yearNumber % 4 == 0) && (yearNumber % 100 != 0)) || (yearNumber % 400 == 0);
        }
        return false;
    }
    /**
     * gets full year
     * @param {?} year
     * @return {?}
     */
    static getFullYear(year) {
        if (year) {
            if (typeof year === 'string') {
                if (year.length == 2) {
                    /** @type {?} */
                    let fullYear = new Date().getFullYear().toString();
                    year = `${fullYear.substr(0, 2)}${year}`;
                }
                return this.toNumber(year);
            }
            else {
                return year;
            }
        }
        return null;
    }
    //#endregion year
    //#region month
    /**
     * verifies if month is valid (1 to 12 | Jan to dec | January to december)
     * @param {?} month
     * @return {?}
     */
    static isValidMonth(month) {
        if (month) {
            /** @type {?} */
            let monthNumber;
            if (typeof month === 'string') {
                monthNumber = this.toNumber(month);
                if (monthNumber == null) {
                    return this.isValidMonthCode(month) || this.isValidMonthName(month);
                }
            }
            else {
                monthNumber = month;
            }
            return this.isValidMonthNumber(monthNumber);
        }
        return false;
    }
    /**
     * verifies if month number is valid (1 to 12)
     * @param {?} month
     * @return {?}
     */
    static isValidMonthNumber(month) {
        if (month &&
            month > 0 &&
            month <= 12) {
            return true;
        }
        return false;
    }
    /**
     * determines if month code is valid (jan to dec)
     * @param {?} month
     * @return {?}
     */
    static isValidMonthCode(month) {
        /** @type {?} */
        let isValid = false;
        /** @type {?} */
        let monthsArr = Object.keys(DateConstant.monthName);
        for (let i = 0; i < monthsArr.length; i++) {
            if (monthsArr[i] == month.toLowerCase()) {
                isValid = true;
                break;
            }
        }
        return isValid;
    }
    /**
     * determines if month name is valid (january to december)
     * @param {?} month
     * @return {?}
     */
    static isValidMonthName(month) {
        /** @type {?} */
        let isValid = false;
        /** @type {?} */
        let monthsArr = Object.values(DateConstant.monthName);
        for (let i = 0; i < monthsArr.length; i++) {
            if (monthsArr[i] == month.toLowerCase()) {
                isValid = true;
                break;
            }
        }
        return isValid;
    }
    /**
     * gets month as number from code/name
     * @param {?} month - code or name as Jan/January etc
     * @return {?}
     */
    static getMonthNumberFromDesc(month) {
        /** @type {?} */
        let monthNumber = null;
        /** @type {?} */
        let monthCodeArr = Object.keys(DateConstant.monthName);
        switch (month.toLowerCase()) {
            case DateConstant.monthName.jan:
            case monthCodeArr[0]:
                monthNumber = 1;
                break;
            case DateConstant.monthName.feb:
            case monthCodeArr[1]:
                monthNumber = 2;
                break;
            case DateConstant.monthName.mar:
            case monthCodeArr[2]:
                monthNumber = 3;
                break;
            case DateConstant.monthName.apr:
            case monthCodeArr[3]:
                monthNumber = 4;
                break;
            case DateConstant.monthName.may:
            case monthCodeArr[4]:
                monthNumber = 5;
                break;
            case DateConstant.monthName.june:
            case monthCodeArr[5]:
                monthNumber = 6;
                break;
            case DateConstant.monthName.july:
            case monthCodeArr[6]:
                monthNumber = 7;
                break;
            case DateConstant.monthName.aug:
            case monthCodeArr[7]:
                monthNumber = 8;
                break;
            case DateConstant.monthName.sep:
            case monthCodeArr[8]:
                monthNumber = 9;
                break;
            case DateConstant.monthName.oct:
            case monthCodeArr[9]:
                monthNumber = 10;
                break;
            case DateConstant.monthName.nov:
            case monthCodeArr[10]:
                monthNumber = 11;
                break;
            case DateConstant.monthName.dec:
            case monthCodeArr[11]:
                monthNumber = 12;
                break;
        }
        return monthNumber;
    }
    /**
     * gets month last date - 28|29|30|31
     * @param {?} month
     * @param {?=} year
     * @return {?}
     */
    static getLastDayOfMonth(month, year = null) {
        if (month) {
            /** @type {?} */
            let monthNumber = this.toNumber(month);
            if (monthNumber == null &&
                typeof month === 'string') {
                //check for month codes and names
                monthNumber = this.getMonthNumberFromDesc(month);
            }
            if (monthNumber != null) {
                /** @type {?} */
                let bigMonths = [1, 3, 5, 7, 8, 10, 12];
                if (monthNumber == 2) {
                    //if year is provided, check for leap year. Else allow till 29
                    if (this.isValidYear(year)) {
                        //Feb - check for leap year
                        if (this.isLeapYear(year)) {
                            return 29;
                        }
                        return 28;
                    }
                    return 29;
                }
                else if (bigMonths.includes(monthNumber)) {
                    return 31;
                }
                else {
                    return 30;
                }
            }
        }
        return null;
    }
    /**
     * returns first date of given date
     * @param {?} date
     * @return {?}
     */
    static getFirstDateOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    }
    /**
     * gets month name by month number
     * @param {?} monthNumber - 1 to 12
     * @return {?}
     */
    static getMonthName(monthNumber) {
        if (monthNumber > 0 && monthNumber <= 12) {
            /** @type {?} */
            let months = Object.values(DateConstant.monthName);
            return months[monthNumber - 1];
        }
        return '';
    }
    /**
     * gets month code by month number (1 to 12)
     * @param {?} monthNumber - 1 to 12
     * @return {?}
     */
    static getMonthCode(monthNumber) {
        if (monthNumber > 0 && monthNumber <= 12) {
            /** @type {?} */
            let months = Object.keys(DateConstant.monthName);
            return months[monthNumber - 1];
        }
        return '';
    }
    //#endregion month
    //#region day
    /**
     * determines if day is valid
     * @param {?} dateVal
     * @param {?=} month
     * @param {?=} year
     * @return {?}
     */
    static isValidDay(dateVal, month = null, year = null) {
        /** @type {?} */
        let dayNum = this.toNumber(dateVal);
        if (dayNum != null && dayNum != NaN && dayNum > 0) {
            //If month is provided, determine day validity wrt month last date
            //Else verify if date is between 1 to 31
            /** @type {?} */
            let lastDate = this.getLastDayOfMonth(month, year);
            if (lastDate != null) {
                return dayNum <= lastDate;
            }
            else {
                return dayNum <= 31;
            }
        }
        return false;
    }
    //#endregion day
    //#region date
    /**
     * determines if given string is current date
     * @param {?} val
     * @param {?=} dateFormat
     * @return {?}
     */
    static isCurrentDateString(val, dateFormat = 'mm/dd/yyyy') {
        if (this.isValidDate(val, dateFormat)) {
            /** @type {?} */
            let inputDate = new Date(val);
            return this.isCurrentDate(inputDate);
        }
        return false;
    }
    /**
     * determines if given date is current date
     * @param {?} val
     * @return {?}
     */
    static isCurrentDate(val) {
        /** @type {?} */
        let currentDate = new Date();
        return this.areSameDates(currentDate, val);
    }
    /**
     * determines if given date is valid
     * @param {?} dateString
     * @param {?=} dateFormat
     * @return {?}
     */
    static isValidDate(dateString, dateFormat = 'mm/dd/yyyy') {
        try {
            if (dateString) {
                if (dateFormat) {
                    /** @type {?} */
                    let model = this.getDatePartInfo(dateFormat);
                    if (model.hasValue()) {
                        /** @type {?} */
                        let dateparts = dateString.split(model.seperator);
                        if (dateparts && dateparts.length == 3) {
                            model.dayModel.value = dateparts[model.dayModel.index];
                            model.monthModel.value = dateparts[model.monthModel.index];
                            model.yearModel.value = dateparts[model.yearModel.index];
                            /** @type {?} */
                            let isYearValid = (this.isValidYear(model.yearModel.value) &&
                                model.yearModel.maxLength == model.yearModel.formattedValue.length);
                            /** @type {?} */
                            let isMonthValid = false;
                            if (model.monthModel.maxLength <= 2) {
                                isMonthValid = this.isValidMonthNumber(Number(model.monthModel.value));
                            }
                            else if (model.monthModel.maxLength > 2 && model.monthModel.maxLength <= 4) {
                                isMonthValid = this.isValidMonthCode(model.monthModel.value);
                            }
                            else {
                                isMonthValid = this.isValidMonthName(model.monthModel.value);
                            }
                            /** @type {?} */
                            let isDayValid = this.isValidDay(model.dayModel.value, model.monthModel.value, model.yearModel.value);
                            return isYearValid && isMonthValid && isDayValid;
                        }
                    }
                }
                else {
                    /** @type {?} */
                    let date = new Date(dateString);
                    if (date.toString() == DateConstant.invalidDateString || date.getFullYear() <= DateConstant.minYear) {
                        return false;
                    }
                    return true;
                }
            }
        }
        catch (_a) { }
        ;
        return false;
    }
    /**
     * gets date difference based on interval
     * @param {?} smallDate
     * @param {?} largeDate
     * @param {?} interval
     * @return {?}
     */
    static dateDifference(smallDate, largeDate, interval) {
        /** @type {?} */
        var second = 1000;
        /** @type {?} */
        var minute = second * 60;
        /** @type {?} */
        var hour = minute * 60;
        /** @type {?} */
        var day = hour * 24;
        /** @type {?} */
        var week = day * 7;
        /** @type {?} */
        var smallDateTime = smallDate.getTime();
        /** @type {?} */
        var largeDateTime = largeDate.getTime();
        /** @type {?} */
        var timediff = largeDateTime - smallDateTime;
        if (isNaN(timediff))
            return NaN;
        switch (interval) {
            case DateConstant.duration.years:
                if (largeDate.getMonth() < smallDate.getMonth() || (largeDate.getMonth() == smallDate.getMonth() && largeDate.getDate() < smallDate.getDate())) {
                    //difference cannot be trated as one full year. Hence subtracting extra -1
                    return (largeDate.getFullYear() - smallDate.getFullYear() - 1);
                }
                else {
                    return largeDate.getFullYear() - smallDate.getFullYear();
                }
            case DateConstant.duration.months:
                return ((largeDate.getFullYear() * 12 + largeDate.getMonth()) - (smallDate.getFullYear() * 12 + smallDate.getMonth()));
            case DateConstant.duration.weeks:
                return Math.floor(timediff / week);
            case DateConstant.duration.days:
                return Math.floor(timediff / day);
            case DateConstant.duration.hours:
                return Math.floor(timediff / hour);
            case DateConstant.duration.minutes:
                return Math.floor(timediff / minute);
            case DateConstant.duration.seconds:
                return Math.floor(timediff / second);
            default:
                return undefined;
        }
    }
    /**
     * determines if given dates are equal
     * @param {?} date1
     * @param {?} date2
     * @return {?}
     */
    static areSameDates(date1, date2) {
        if (date1.getUTCDate() == date2.getUTCDate() &&
            date1.getUTCMonth() == date2.getUTCMonth() &&
            date1.getUTCFullYear() == date2.getUTCFullYear()) {
            return true;
        }
        return false;
    }
    /**
     * determines if given dates have same date part
     * @param {?} date1
     * @param {?} date2
     * @param {?} datePart - valid values are days|months|years
     * @return {?}
     */
    static isSameDatePart(date1, date2, datePart) {
        /** @type {?} */
        let output = false;
        switch (datePart) {
            case DateConstant.duration.days:
                output = date1.getDate() == date2.getDate();
                break;
            case DateConstant.duration.months:
                output = date1.getMonth() == date2.getMonth();
                break;
            case DateConstant.duration.years:
                output = date1.getFullYear() == date2.getFullYear();
                break;
        }
        return output;
    }
    /**
     * increments by datepart and gets date
     * @param {?} dateVal - value of the date
     * @param {?} count - count to increase
     * @param {?} datePart - part of the date - days|months|years
     * @return {?}
     */
    static add(dateVal, count, datePart) {
        /** @type {?} */
        let newDate = dateVal.getDate();
        /** @type {?} */
        let newMonth = dateVal.getMonth();
        /** @type {?} */
        let newYear = dateVal.getFullYear();
        switch (datePart) {
            case DateConstant.duration.days:
                newDate = newDate + count;
                break;
            case DateConstant.duration.months:
                newMonth = newMonth + count;
                break;
            case DateConstant.duration.years:
                newYear = newYear + count;
                break;
        }
        return new Date(newYear, newMonth, newDate);
    }
    /**
     * decreaments by datepart and gets date
     * @param {?} dateVal - value of the date
     * @param {?} count - count to increase
     * @param {?} datePart - part of the date - days|months|years
     * @return {?}
     */
    static subtract(dateVal, count, datePart) {
        /** @type {?} */
        let newDate = dateVal.getDate();
        /** @type {?} */
        let newMonth = dateVal.getMonth();
        /** @type {?} */
        let newYear = dateVal.getFullYear();
        switch (datePart) {
            case DateConstant.duration.days:
                newDate = newDate - count;
                break;
            case DateConstant.duration.months:
                newMonth = newMonth - count;
                break;
            case DateConstant.duration.years:
                newYear = newYear - count;
                break;
        }
        return new Date(newYear, newMonth, newDate);
    }
    /**
     * gets date part information
     * @param {?} dateFormat
     * @return {?}
     */
    static getDatePartInfo(dateFormat) {
        /** @type {?} */
        let model = new DateModel();
        switch (dateFormat) {
            case DateConstant.dateformat.ddmmyyyy_dot:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.dot, 2);
                break;
            case DateConstant.dateformat.ddmmyy_dot:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.dot, 2, 2);
                break;
            case DateConstant.dateformat.ddmmyyyy_hyphen:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.hyphen, 2);
                break;
            case DateConstant.dateformat.ddmmyy_hyphen:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.hyphen, 2, 2);
                break;
            case DateConstant.dateformat.ddmmyyyy_slash:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.slash, 2);
                break;
            case DateConstant.dateformat.ddmmyy_slash:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.slash, 2, 2);
                break;
            case DateConstant.dateformat.dd_month_yyyy_space:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.space, 9);
                break;
            case DateConstant.dateformat.dd_mon_yyyy_space:
                model.setValues(0, 1, 2, DateConstant.dateSeperator.space, 4);
                break;
            case DateConstant.dateformat.mmddyyyy_dot:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.dot, 2);
                break;
            case DateConstant.dateformat.mmddyy_dot:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.dot, 2, 2);
                break;
            case DateConstant.dateformat.mmddyyyy_hyphen:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.hyphen, 2);
                break;
            case DateConstant.dateformat.mmddyy_hyphen:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.hyphen, 2, 2);
                break;
            case DateConstant.dateformat.mmddyyyy_slash:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.slash, 2);
                break;
            case DateConstant.dateformat.mmddyy_slash:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.slash, 2, 2);
                break;
            case DateConstant.dateformat.month_dd_yyyy_space:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.space, 9);
                break;
            case DateConstant.dateformat.mon_dd_yyyy_space:
                model.setValues(1, 0, 2, DateConstant.dateSeperator.space, 4);
                break;
            case DateConstant.dateformat.yyyymmdd_slash:
                model.setValues(2, 1, 0, DateConstant.dateSeperator.slash, 2);
                break;
            case DateConstant.dateformat.yyyy_mon_dd_space:
                model.setValues(2, 1, 0, DateConstant.dateSeperator.space, 4);
                break;
            case DateConstant.dateformat.yyyy_month_dd_space:
                model.setValues(2, 1, 0, DateConstant.dateSeperator.space, 9);
                break;
        }
        if (model.hasValue()) {
            model.datePartSorted = [model.dayModel, model.monthModel, model.yearModel].sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => {
                if (a.index > b.index) {
                    return 1;
                }
                else if (a.index < b.index) {
                    return -1;
                }
                return 0;
            }));
        }
        return model;
    }
    /**
     * gets date as specified format string
     * @param {?} dateValue
     * @param {?} format
     * @return {?}
     */
    static getDateAsString(dateValue, format) {
        /** @type {?} */
        let value = '';
        if (this.isValid(dateValue)) {
            /** @type {?} */
            let dateModel = this.getDatePartInfo(format);
            if (dateModel.hasValue() && dateModel.datePartSorted && dateModel.datePartSorted.length == 3) {
                dateModel.dayModel.value = dateValue.getDate();
                if (dateModel.monthModel.maxLength == 2) {
                    dateModel.monthModel.value = dateValue.getMonth() + 1;
                }
                else if (dateModel.monthModel.maxLength <= 4) {
                    dateModel.monthModel.value = this.getMonthCode(dateValue.getMonth() + 1);
                }
                else {
                    dateModel.monthModel.value = this.getMonthName(dateValue.getMonth() + 1);
                }
                dateModel.yearModel.value = dateValue.getFullYear();
                value = `${dateModel.datePartSorted[0].formattedValue}${dateModel.seperator}${dateModel.datePartSorted[1].formattedValue}${dateModel.seperator}${dateModel.datePartSorted[2].formattedValue}`;
            }
        }
        return value;
    }
    /**
     * gets string as Date
     * @param {?} dateValue
     * @param {?} format
     * @return {?}
     */
    static getStringAsDate(dateValue, format) {
        if (this.isValidDate(dateValue, format)) {
            /** @type {?} */
            let dateModel = this.getDatePartInfo(format);
            if (dateModel.hasValue() && dateModel.datePartSorted && dateModel.datePartSorted.length == 3) {
                /** @type {?} */
                let datePartValues = dateValue.split(dateModel.seperator);
                if (datePartValues.length == 3) {
                    datePartValues.forEach((/**
                     * @param {?} val
                     * @param {?} index
                     * @return {?}
                     */
                    (val, index) => {
                        dateModel.datePartSorted[index].value = val;
                    }));
                    return new Date((/** @type {?} */ (dateModel.yearModel.value)), (/** @type {?} */ (dateModel.monthModel.value)), (/** @type {?} */ (dateModel.dayModel.value)));
                }
            }
        }
        return null;
    }
    /**
     * determines if value is valid date
     * @param {?} date
     * @return {?}
     */
    static isValid(date) {
        return (date && date instanceof Date && !isNaN(date.valueOf()));
    }
    //#endregion date
    //#endregion public functions
    //#region private functions
    /**
     * gets string as number
     * @private
     * @param {?} value
     * @return {?}
     */
    static toNumber(value) {
        if (value) {
            if (typeof value === 'string') {
                try {
                    /** @type {?} */
                    let n = Number(value);
                    if (!Number.isNaN(n)) {
                        return n;
                    }
                }
                catch (e) {
                    return null;
                }
            }
            else {
                if (!Number.isNaN(value)) {
                    return value;
                }
            }
        }
        return null;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helper/string/string.helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class StringHelper {
    //#region model properties
    //#endregion model properties
    //#region constructor
    constructor() {
    }
    //#endregion constructor
    //#region public functions
    /**
     * Compares given strings and returns result
     * @param {?} newVal
     * @param {?} originalVal
     * @param {?} ignoreCase
     * @param {?} useLocale
     * @return {?}
     */
    static compareStrings(newVal, originalVal, ignoreCase, useLocale) {
        if (newVal != undefined && originalVal != null) {
            if (ignoreCase) {
                if (useLocale) {
                    newVal = newVal.toLocaleLowerCase();
                    originalVal = originalVal.toLocaleLowerCase();
                }
                else {
                    newVal = newVal.toLowerCase();
                    originalVal = originalVal.toLowerCase();
                }
            }
        }
        return newVal === originalVal;
    }
    /**
     * String Format method
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    static format(value, ...args) {
        try {
            /** @type {?} */
            let val = '';
            /** @type {?} */
            let matches = value.match(/{(\d+)}/g);
            if (matches && matches.length > 0) {
                val = value;
                for (let i = 0; i < matches.length; i++) {
                    if (args[i] == undefined || args[i] == null) {
                        args[i] = '';
                    }
                    val = val.replace(matches[i], args[i]);
                }
            }
            else {
                return value;
            }
            return val;
        }
        catch (e) {
            return '';
        }
    }
    /**
     * concats given args
     * @param {...?} args
     * @return {?}
     */
    static concat(...args) {
        /** @type {?} */
        let outValue = '';
        if (args && args.length > 0) {
            for (let i = 0; i < args.length; i++) {
                outValue = `${outValue}${args[i]}`;
            }
        }
        return outValue;
    }
    /**
     * trims the string by handling nulls
     * @param {?} value
     * @return {?}
     */
    static toSafeTrim(value) {
        if (value != undefined && value != null) {
            return value.trim();
        }
        return '';
    }
    /**
     * converts all the alphabetic characters in a string to lowercase by handling nulls
     * @param {?} value
     * @return {?}
     */
    static toSafeLowe(value) {
        if (value != undefined && value != null) {
            return value.toLowerCase();
        }
        return '';
    }
    /**
     * converts all the alphabetic characters in a string to uppercase by handling nulls
     * @param {?} value
     * @return {?}
     */
    static toSafeUpper(value) {
        if (value != undefined && value != null) {
            return value.toUpperCase();
        }
        return '';
    }
    /**
     * converts given string to first letter capital
     * @param {?} value
     * @return {?}
     */
    static toFirstLetterCapital(value) {
        value = this.toSafeTrim(value);
        if (value) {
            /** @type {?} */
            let first = this.toSafeUpper(value.charAt(0));
            if (value.length > 1) {
                return `${first}${value.substring(1, value.length)}`;
            }
            else {
                return first;
            }
        }
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class FieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        this.isVisible = new BehaviorSubject(null);
    }
}
if (false) {
    /** @type {?} */
    FieldModel.prototype.id;
    /** @type {?} */
    FieldModel.prototype.fieldCode;
    /** @type {?} */
    FieldModel.prototype.displayLabelText;
    /** @type {?} */
    FieldModel.prototype.isVisible;
    /** @type {?} */
    FieldModel.prototype.fieldControlType;
    /** @type {?} */
    FieldModel.prototype.cssClass;
    /** @type {?} */
    FieldModel.prototype.displayLabelCss;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: colibrium-abp-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpBaseConstant, ConversionHelper, DateConstant, DateHelper, DateModel, DatePartModel, FieldModel, FieldType, StringHelper };

//# sourceMappingURL=colibrium-abp-base.js.map